import { useAppConfig } from '../../acl/acl-provider.tsx';

export const useAskPlatoEnabled = (): boolean => {
    const { enableAiChat } = useAppConfig();

    return enableAiChat;
};
